module.exports = __webpack_public_path__ + "design-duo.jpg?cee4b51fff6a26b2d339e0504df9b5a1";


//////////////////
// WEBPACK FOOTER
// ./src/images/design-duo.jpg
// module id = 300
// module chunks = 0